/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PricingInputs */

const en_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const es_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios`)
};

const fr_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarification`)
};

const de_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisgestaltung`)
};

const ja_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格設定`)
};

const zh_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定价`)
};

const ar_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التسعير`)
};

const id_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

const it_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi`)
};

const ru_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цены`)
};

const pt_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preços`)
};

const ko_pricing = /** @type {(inputs: PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가격`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {PricingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing = /** @type {((inputs?: PricingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PricingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing(inputs)
	if (locale === "es") return es_pricing(inputs)
	if (locale === "fr") return fr_pricing(inputs)
	if (locale === "de") return de_pricing(inputs)
	if (locale === "ja") return ja_pricing(inputs)
	if (locale === "zh") return zh_pricing(inputs)
	if (locale === "ar") return ar_pricing(inputs)
	if (locale === "id") return id_pricing(inputs)
	if (locale === "it") return it_pricing(inputs)
	if (locale === "ru") return ru_pricing(inputs)
	if (locale === "pt") return pt_pricing(inputs)
	return ko_pricing(inputs)
});